import { ChipSelect, ChipSelectProps } from 'components/ChipSelect/ChipSelect'
import { Item } from '@react-stately/collections'
import { Selection } from '@react-types/shared'
import { RevisionAction } from '../Types'

interface Props extends Pick<ChipSelectProps, 'selectionMode' | 'limit'> {
  onChange: (action: RevisionAction) => void
  selectedAction: RevisionAction
  inline?: boolean
}

export const ChangeLengthActionSelect = ({ onChange, selectedAction }: Props) => {
  const handleChange = (selection: Selection) => {
    if (!(selection instanceof Set)) return

    const [action] = selection
    onChange(action as RevisionAction)
  }

  const selectedKey = selectedAction ? [selectedAction.toString()] : []

  return (
    <ChipSelect selectedKeys={selectedKey} selectionMode="single" deletable={false} onSelectionChange={handleChange}>
      <Item key={RevisionAction.MAKE_SHORTER}>Make shorter</Item>
      <Item key={RevisionAction.MAKE_LONGER}>Make longer</Item>
      <Item key={RevisionAction.SUMMARIZE}>Summarize</Item>
      <Item key={RevisionAction.SIMPLIFY}>Simplify</Item>
    </ChipSelect>
  )
}
